
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g7Es71gm6BH4IIG_45FOm5_rIz62_JRaXAvHsPniV5e2NYMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexEwfHxgG0g5sdi5WLzuFAjdTEbDbiA1ZtUqdVrPQgg2kMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchhuemz4kLP0agQI81aT1pXl_nKAHRGvgsFd5rb70acpIMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbwwiTv3Jex7w1RC3yHkWw4DYYrV6hIovMWsuO7vbN8cMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93_45zaI8WeHRHeBgCIL_mO3cpYms3v6jOYCq9X_u_45tnrRYMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexnhFnfBJZ3UFtg_45TpKoXd24l0YOyg1q1ULm3yD7ILJeIMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93fjapuWk6I1XSOfcQd4LB0exm7pkPkeRVcR7MK8NoeBYMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexIivdAHl3r1zCsOAuB8_455E_X4F_3TgP0VfAG_45pHMuNPgMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93FPOU7VdlXcBHBuivODDKQmYguKGf_45sS97TTuS5i9nwUMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index8XoFuf1BkRGQIKn8ZUjVgJuMOZM6TNf4Fr1o1tAHjG8Meta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexbF5o1WcsP9Ya7isZY2hdoFVaE5KTPJESVjjH4E1H_45_QMeta } from "/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexnhFnfBJZ3UFtg_45TpKoXd24l0YOyg1q1ULm3yD7ILJeIMeta || {},
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexIivdAHl3r1zCsOAuB8_455E_X4F_3TgP0VfAG_45pHMuNPgMeta || {},
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index8XoFuf1BkRGQIKn8ZUjVgJuMOZM6TNf4Fr1o1tAHjG8Meta || {},
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexbF5o1WcsP9Ya7isZY2hdoFVaE5KTPJESVjjH4E1H_45_QMeta || {},
    component: () => import("/codebuild/output/src1162536989/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]